import { Map, List, fromJS } from 'immutable'
import { handleActions, combineActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

// constants
export const FETCH_USER_GROUP_LIST = 'userGroup/FETCH_USER_GROUP_LIST'
export const SUCCESS_USER_GROUP_LIST = 'userGroup/SUCCESS_USER_GROUP_LIST'
export const FAILURE_USER_GROUP_LIST = 'userGroup/FAILURE_USER_GROUP_LIST'
export const LOAD_USER_GROUP_LIST = 'userGroup/LOAD_USER_GROUP_LIST'

export const FETCH_USER_GROUP_TABLE = 'userGroup/FETCH_USER_GROUP_TABLE'
export const SUCCESS_USER_GROUP_TABLE = 'userGroup/SUCCESS_USER_GROUP_TABLE'
export const FAILURE_USER_GROUP_TABLE = 'userGroup/FAILURE_USER_GROUP_TABLE'
export const LOAD_USER_GROUP_TABLE = 'userGroup/LOAD_USER_GROUP_TABLE'

export const FETCH_USER_GROUP_FORM = 'userGroup/FETCH_USER_GROUP_FORM'
export const SUCCESS_USER_GROUP_FORM = 'userGroup/SUCCESS_USER_GROUP_FORM'
export const FAILURE_USER_GROUP_FORM = 'userGroup/FAILURE_USER_GROUP_FORM'
export const LOAD_USER_GROUP_FORM = 'userGroup/LOAD_USER_GROUP_FORM'

export const SET_USER_GROUP_INFO = 'userGroup/SET_USER_GROUP_INFO'
export const DELETE_USER_GROUP_INFO = 'userGroup/DELETE_USER_GROUP_INFO'

export const CLEAR_USER_GROUP_LIST = 'userGroup/CLEAR_USER_GROUP_LIST'
export const CLEAR_USER_GROUP_TABLE = 'userGroup/CLEAR_USER_GROUP_TABLE'
export const CLEAR_USER_GROUP_FORM = 'userGroup/CLEAR_USER_GROUP_FORM'
export const CLEAR_USER_GROUP_STORE = 'userGroup/CLEAR_USER_GROUP_STORE'

// actions
export const fetchUserGroupList = ActionHelper.createActionObj(
  FETCH_USER_GROUP_LIST,
)
export const fetchUserGroupTable = ActionHelper.createActionObj(
  FETCH_USER_GROUP_TABLE,
)
export const fetchUserGroupForm = ActionHelper.createActionObj(
  FETCH_USER_GROUP_FORM,
)
export const setUserGroupInfo = ActionHelper.createActionObj(
  SET_USER_GROUP_INFO,
)
export const deleteUserGroupInfo = ActionHelper.createActionObj(
  DELETE_USER_GROUP_INFO,
)
export const clearUserGroupList = ActionHelper.createActionObj(
  CLEAR_USER_GROUP_LIST,
)
export const clearUserGroupTable = ActionHelper.createActionObj(
  CLEAR_USER_GROUP_TABLE,
)
export const clearUserGroupForm = ActionHelper.createActionObj(
  CLEAR_USER_GROUP_FORM,
)
export const clearUserGroupStore = ActionHelper.createActionObj(
  CLEAR_USER_GROUP_STORE,
)

// state
const initialState = () =>
  fromJS({
    isLoadList: false,
    isLoadTable: false,
    isLoadForm: false,
    userGroupList: [],
    tableData: {
      data: [],
      count: 0,
    },
    formData: {
      users: [],
      applications: [],
      userGroup: null,
    },
  })

// reducers
const userGroup = handleActions(
  {
    [LOAD_USER_GROUP_LIST]: (state, action) =>
      state.set('isLoadList', Boolean(action.payload)),
    [SUCCESS_USER_GROUP_LIST]: (state, action) =>
      state.set('userGroupList', List(action.payload)),
    [combineActions(FAILURE_USER_GROUP_LIST, CLEAR_USER_GROUP_LIST)]: state =>
      state.set('userGroupList', List([])),

    [LOAD_USER_GROUP_TABLE]: (state, action) =>
      state.set('isLoadTable', Boolean(action.payload)),
    [SUCCESS_USER_GROUP_TABLE]: (state, action) =>
      state.set('tableData', Map(action.payload)),
    [combineActions(FAILURE_USER_GROUP_TABLE, CLEAR_USER_GROUP_TABLE)]: state =>
      state.set(
        'tableData',
        Map({
          data: [],
          count: 0,
        }),
      ),

    [LOAD_USER_GROUP_FORM]: (state, action) =>
      state.set('isLoadForm', Boolean(action.payload)),
    [SUCCESS_USER_GROUP_FORM]: (state, action) =>
      state.set('formData', Map(action.payload)),
    [combineActions(FAILURE_USER_GROUP_FORM, CLEAR_USER_GROUP_FORM)]: state =>
      state.set(
        'formData',
        Map({
          users: [],
          applications: [],
          userGroup: null,
        }),
      ),

    [CLEAR_USER_GROUP_STORE]: () => initialState(),
  },
  initialState(),
)

export default userGroup
